import { apiClient, type ShipmentOrderImportFormatEntity } from '@/libs/api'

export type FetchShipmentOrderImportFormatsQuery = {
  tenantKey: string
  dcId: number
}

/** 拠点の保存フォーマット一覧（名前順）。 */
export const fetchShipmentOrderImportFormats = async (
  { tenantKey, dcId }: FetchShipmentOrderImportFormatsQuery,
  signal?: AbortSignal
): Promise<ShipmentOrderImportFormatEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_formats.$get({ query: { dcId }, config: { signal } })
  return data
}
